import { isWithinHours } from "@gigpro/utils/datetime";
import type { SkillListItemReadonly, ForManagerLocationDetail } from "@sidegigllc/api/client";
import type { Pro, SectionShift } from "domains/postGig/providers/PostGigData/types";

type GetDefaults = (options: {
  skillId: number;
  skills: Array<SkillListItemReadonly>;
  shift: SectionShift;
  location: ForManagerLocationDetail;
}) => Partial<Pro> | undefined;

export const getDefault: GetDefaults = ({ skillId, skills, shift: { startTime, timezone }, location }) => {
  const skill = skills?.find(({ id }) => id === skillId);
  if (!skill) return;
  const hourlyRate =
    (isWithinHours(startTime, 24, timezone) ? skill.recommended_wage_amount_boosted : skill.recommended_wage_amount) ??
    0;
  return {
    skill_id: skill.id,
    skill_name: skill.name,
    position_description: skill.default_description ?? "",
    no_experience_required: false,
    hourly_rate: hourlyRate,
    location_id: location.id,
    requirements: [],
    private_notes: "",
    auto_select_enabled: location.immediate_auto_select_enabled,
  };
};
